<template>
  <div class="content-common-detail-container content-bg" :class="{
    isMobile: isMobile()
  }">
    <div class="sys-max-width content-detail">
      <detailNav
        :title="detailInfo.title"
        :pid="detailInfo.pid"
        :moduleName="moduleData.name"
      />

      <div class="content-detail-box lg-mx flex">
        <div class="left">

          <top
            :detailInfo="detailInfo"
          />

          <div class="content-text">
            <div v-html="detailInfo.contents"></div>
          </div>

          <div class="bottom-link flex items-center justify-between">
            <div class="flex" v-if="detailInfo.pre">
              <div class="text">上一篇：</div>
              <div @click="goDetail(detailInfo.pre)" class="content-title ellipsis">{{ detailInfo.pre.title }}</div>
            </div>
            <div class="flex" v-if="detailInfo.next">
              <div class="text">下一篇：</div>
              <div @click="goDetail(detailInfo.next)" class="content-title ellipsis">{{ detailInfo.next.title }}</div>
            </div>
          </div>
        </div>

        <div class="right" v-if="!isMobile()">
          <div class="common-block news">
            <div class="top flex items-start">
              <div class="icon"></div>
              <div class="title">{{ newsData.name }}</div>
            </div>

            <div class="list">
              <div @click="goDetail(item)" :key="index" v-for="(item, index) in newsRecommandList" class="item flex justify-between items-start">
                <div class="list-left">
                  <div class="icon"></div>
                </div>

                <div class="list-right">
                  <div class="content">{{ item.title }}</div>

                  <div class="time">{{ item.create_time }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="common-block welfare">
            <div class="top flex items-start">
              <div class="icon"></div>
              <div class="title">{{ welfareData.name }}</div>
            </div>

            <div class="list">
              <div @click="goDetail(item)" :key="index" v-for="(item, index) in welfareRecommandList" class="item flex justify-center">
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
/* eslint-disable */
import { MODULE_CONFIG } from '@/config/index'
import { fetchContentDetail } from '@/api/content'
import { fetchRecommendList } from '@/api/common'
import { isMobile } from '@/utils/index'

import detailNav from './detailNav'
import top from './top'

export default {
  components: {
    detailNav,
    top
  },
  data() {
    const { moduleId, moduleSecId, contentId } = this.$route.query

    return {
      contentId,
      moduleId,
      moduleSecId,

      detailInfo: {},

      newsRecommandList: [],
      welfareRecommandList: []
    }
  },
  computed: {
    moduleData() {
      return this.$store.getters.getModuleItemById(this.moduleId)
    },

    newsData() {
      return this.$store.getters.getModuleItemById(MODULE_CONFIG.NEWS)
    },

    welfareData() {
      return this.$store.getters.getModuleItemById(MODULE_CONFIG.WELFARE)
    }
  },
  watch: {
    $route(newVal) {
      const { moduleId, moduleSecId, contentId } = newVal.query

      this.contentId = contentId
      this.moduleId = moduleId
      this.moduleSecId = moduleSecId

      this.getContentDetail()
    }
  },
  methods: {
    isMobile,
    async getContentDetail() {
      try {
        this.detailInfo = await fetchContentDetail({
          object_code: this.contentId
        })
      } catch (error) {

      }
    },

    goDetail(item) {
      this.$router.push({
        name: 'contentDetail',
        query: {
          moduleId: item.pid,
          moduleSecId: item.cate_id,
          contentId: item.object_code
        }
      })
    },

    async getNewsRecommandList() {
      try {
        this.newsRecommandList = await fetchRecommendList({
          pid: MODULE_CONFIG.NEWS,
          count: 5
        })
      } catch (error) {

      }
    },

    async getWelfareRecommandList() {
      try {
        this.welfareRecommandList = await fetchRecommendList({
          pid: MODULE_CONFIG.WELFARE,
          count: 999 // TODO:
        })
      } catch (error) {
        console.log(error)
      }
    },
  },
  created() {
    this.getWelfareRecommandList()
    this.getNewsRecommandList()

    if (this.contentId) {
      this.getContentDetail()
    }
  }
}
</script>

<style lang="scss">
.content-common-detail-container {

  &.isMobile {
    .content-detail {
      padding-bottom: 40px;
      .content-detail-box {

        .left {
          width: 100%;
        }

        .bottom-link {
          display: block;
        }
      }
    }
  }

  .content-detail {
    padding: 46px 0 124px;

    .content-detail-box {

      .left {

        flex-grow: 1;



        .content-text {
          padding: 26px 0;
          line-height: 33px;
          border-top: 1px solid rgba(0, 0, 0, 0.1);
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        }

        .bottom-link {
          margin-top: 33px;

          .flex {
            font-size: 14px;
            .text {
              color: #878A95;
            }

            .content-title {
              font-size: 14px;
              cursor: pointer;
              color: $primary;
              max-width: 230px;
            }
          }
        }
      }

      .right {
        // width: ;
        width: 355px;
        margin-left: 60px;
        // flex: 0 0 25%;
        flex-shrink: 0;

        // background: $primary;

        .common-block {
          background: #FFFFFF;
          box-shadow: 0px 0px 10px 0px rgba(26, 104, 202, 0.1);
          border-radius: 10px;
          padding: 25px 18px;
          margin-bottom: 25px;



          &.news {
            .top {
              margin-bottom: 28px;
              .icon {
                width: 32px;
                height: 26px;
                margin-right: 10px;
                background: url(~@/assets/recommend-news.png) no-repeat;
              background-size: 100% 100%;
              }

              .title {
                font-size: 16px;

                font-weight: normal;
                color: #0A1121;
                line-height: 24px;
              }
            }

            .list {
              .item {
                margin-bottom: 28px;
                cursor: pointer;

                &:hover {
                  .content {
                    color: $primary !important;
                  }
                }

                &:last-child {
                  margin-bottom: 0;
                }

                .list-left {
                  // flex: 0 0 5%;
                  flex-shrink: 0;
                  margin-right: 10px;
                  .icon {
                    margin-top: 6px;
                    width: 5px;
                    height: 10px;

                    background: url(~@/assets/sx-icon.png) no-repeat;
                    background-size: 100% 100%;
                  }
                }

                .list-right {
                  // flex: 0 0 90%;
                  flex-grow: 1;
                  .content {
                    font-size: 14px;
                    font-weight: normal;
                    color: #0A1121;
                    line-height: 20px;
                    margin-bottom: 8px;
                  }

                  .time {
                    font-size: 14px;
                    font-weight: 400;
                    color: #878A95;
                  }
                }
              }
            }
          }

          &.welfare {
            .top {
              margin-bottom: 28px;
              .icon {
                width: 24px;
                height: 26px;
                margin-right: 10px;
                background: url(~@/assets/recommend-welfy.png) no-repeat;
                background-size: 100% 100%;
              }

              .title {
                font-size: 16px;

                font-weight: normal;
                color: #0A1121;
                line-height: 24px;
              }


            }

            .list {
              .item {
                height: 40px;
                line-height: 40px;
                background: #fff;
                border: 1px solid #D9DFEA;
                border-radius: 5px;
                font-size: 14px;
                color: #596270;
                // text-align: center;
                margin-bottom: 10px;
                cursor: pointer;

                &:last-child {
                  margin-bottom: 0px;
                }

                &:hover {
                  background: #F4F7FC;
                }
              }
            }
          }
        }
      }
    }
  }

}
</style>
